import {
  select,
  takeLatest,
  put,
  call,
  all,
  takeEvery,
  throttle
} from "redux-saga/effects";
import {
  UPDATE_PROFILE_SELECTED_BUDDY,
  setUpdatedProfileSelectedBuddy,
  UPLOAD_RM_BUDDIES,
  SET_RM_BUDDIES_SERVER_SEARCH_QUERY,
  setRmBuddiesSearchResults,
  ASSIGN_RM_BUDDY,
  setRmBuddiesList,
  SET_RM_BUDDIES_WAREHOUSE_ID,
  setBuddyBlocksList,
  FETCH_LEAVES,
  APPLY_LEAVES,
  setSelectedRmBuddyLeaves,
  setSelectedRmBuddyId,
  REMOVE_LEAVES
} from "../actions";
import {
  updateRmBuddyProfile,
  uploadRmBuddies,
  searchRmBuddies,
  removeFromGeofence,
  assignToGeofence,
  getRmBuddiesByGeofence,
  getRmBuddiesByWarehouseId,
  getBuddyBlocksNamesFromWarehouseId,
  getLeaves,
  applyLeaves,
  removeLeaves
} from "../../../api/rm-buddies";

// TODO seperate them outof geofenceto a common actions andreducer folder
import {
  setLoaderModal,
  setUserAuthenticated,
  setReplayOnAuthentication,
  setErrorToastMessage,
  setAssignedBuddies,
  VIEW_ASSIGNED_BUDDIES,
  setSuccessToastMessage
} from "../../geofence/actions";

import { setUploadRmBuddiesStatus } from "../../rm-buddies/actions";

export function* updateProfileSelectedBuddyTask(action) {
  yield put(setLoaderModal(true));
  try {
    const _id = yield select(({ rmBuddies }) => rmBuddies.selectedRmBuddyId);
    const { email, name, mobileNumber } = action.payload;
    const result = yield call(updateRmBuddyProfile, {
      _id,
      email,
      name,
      mobileNumber
    });
    yield put(setSuccessToastMessage(result.data.message));
    yield put(setUpdatedProfileSelectedBuddy(action.payload));
  } catch (e) {
    console.error(e);
    if (e.response.status === 401) {
      yield put(setUserAuthenticated(false));
      yield put(setReplayOnAuthentication(action));
    }
    yield put(setErrorToastMessage(e.response.data.message));
  }
  yield put(setLoaderModal(false));
}

export function* watchEditProfileSelectedRmBuddy() {
  yield takeLatest(
    UPDATE_PROFILE_SELECTED_BUDDY,
    updateProfileSelectedBuddyTask
  );
}
export function* uploadRmBuddiesExcelTask(action) {
  yield put(setLoaderModal(true));
  try {
    yield call(uploadRmBuddies, action.payload);
    yield put(setUploadRmBuddiesStatus({ msg: "File Uploaded" }));
  } catch (e) {
    alert("Some error occured while uploading the file. Please try again.");
    console.error(e);
    if (e.response.status === 401) {
      yield put(setUserAuthenticated(false));
      yield put(setReplayOnAuthentication(action));
    }
    yield put(setErrorToastMessage(e.response.data.message));
    yield put(
      setUploadRmBuddiesStatus({
        msg:
          "Some error occured please try again. Contact tech team if error persists."
      })
    );
  }
  yield put(setLoaderModal(false));
}

export function* watchUploadRmBuddies() {
  yield takeLatest(UPLOAD_RM_BUDDIES, uploadRmBuddiesExcelTask);
}

export const rmBuddySchemaMapper = e => ({
  _id: e._id,
  phone_num: e.mobileNumber,
  name: e.name,
  city: e.city,
  email: e.email,
  buddy_block_ids: e.geofenceIds,
  task_count: e.taskCount
});
export const rmBuddyBlockMapper = e => ({
  _id: e._id,
  properties: {
    name: e.name,
    fenceCategory: "BUDDY_BLOCK"
  }
});

export function* getRmBuddiesAndBlocksByWarehouseIdTask(action) {
  if (!action.payload) {
    return;
  }
  yield put(setLoaderModal(true));
  try {
    const [buddiesRes, blocksRes] = yield all([
      call(getRmBuddiesByWarehouseId, action.payload),
      call(getBuddyBlocksNamesFromWarehouseId, action.payload)
    ]);
    const { data } = buddiesRes;
    const buddyBlocksNames = blocksRes.data.buddyBlocksNames.map(
      rmBuddyBlockMapper
    );
    const mappedResults = data.list.map(rmBuddySchemaMapper);
    yield put(setRmBuddiesList(mappedResults));
    yield put(setBuddyBlocksList(buddyBlocksNames));
  } catch (e) {
    console.error(e);
    if (e.response.status === 401) {
      yield put(setUserAuthenticated(false));
      yield put(setReplayOnAuthentication(action));
    }
    yield put(setErrorToastMessage(e.response.data.message));
  }
  yield put(setLoaderModal(false));
}

export function* watchRmBuddiesWarehouseId() {
  yield takeEvery(
    SET_RM_BUDDIES_WAREHOUSE_ID,
    getRmBuddiesAndBlocksByWarehouseIdTask
  );
}

export function* serverSideRmBuddiesSearchTask(action) {
  if (!action.payload) {
    yield put(setRmBuddiesSearchResults(null));
    return;
  }
  yield put(setLoaderModal(true));
  try {
    const { data } = yield call(searchRmBuddies, action.payload);
    const mappedResults = data.map(rmBuddySchemaMapper);
    yield put(setRmBuddiesSearchResults(mappedResults));
  } catch (e) {
    console.error(e);
    if (e.response.status === 401) {
      yield put(setUserAuthenticated(false));
      yield put(setReplayOnAuthentication(action));
    }
    yield put(setErrorToastMessage(e.response.data.message));
  }
  yield put(setLoaderModal(false));
}

export function* watchRmBuddiesServerSearch() {
  yield throttle(
    800,
    SET_RM_BUDDIES_SERVER_SEARCH_QUERY,
    serverSideRmBuddiesSearchTask
  );
}

export function* getRmBuddiesByGeofenceTask(action) {
  if (!action.payload) {
    yield put(setRmBuddiesSearchResults(null));
    return;
  }
  yield put(setLoaderModal(true));
  try {
    const { data } = yield call(getRmBuddiesByGeofence, action.payload);
    const mappedResults = data.map(rmBuddySchemaMapper);
    yield put(setAssignedBuddies(mappedResults));
  } catch (e) {
    console.error(e);
    if (e.response.status === 401) {
      yield put(setUserAuthenticated(false));
      yield put(setReplayOnAuthentication(action));
    }
    yield put(setErrorToastMessage(e.response.data.message));
  }
  yield put(setLoaderModal(false));
}

export function* watchViewAssignedBuddy() {
  yield takeLatest(VIEW_ASSIGNED_BUDDIES, getRmBuddiesByGeofenceTask);
}

export function* assignRmBuddyToBuddyBlockTask(action) {
  if (!action.payload) {
    return;
  }
  yield put(setLoaderModal(true));
  try {
    if (action.payload.old_buddy_id) {
      yield call(removeFromGeofence, {
        geofenceId: action.payload.buddy_block_id,
        rmBuddyId: action.payload.old_buddy_id
      });
    }
    if (action.payload.new_buddy_id) {
      yield call(assignToGeofence, {
        geofenceId: action.payload.buddy_block_id,
        rmBuddyId: action.payload.new_buddy_id
      });
    }
    // refetch the RM buddies list for warehouse id if it's set
    const warehouseId = yield select(
      ({ rmBuddies }) => rmBuddies.currentWarehouseId
    );
    yield call(getRmBuddiesAndBlocksByWarehouseIdTask, {
      payload: warehouseId
    });
  } catch (e) {
    console.error(e);
    if (e.response.status === 401) {
      yield put(setUserAuthenticated(false));
      yield put(setReplayOnAuthentication(action));
    }
    yield put(setErrorToastMessage(e.response.data.message));
  }
  yield put(setLoaderModal(false));
}

export function* watchAssignBuddy() {
  yield takeLatest(ASSIGN_RM_BUDDY, assignRmBuddyToBuddyBlockTask);
}

export function* fetchLeavesTask(action) {
  if (!action.payload) {
    return;
  }
  yield put(setLoaderModal(true));
  try {
    const rmBuddyId = yield select(
      ({ rmBuddies }) => rmBuddies.selectedRmBuddyId
    );

    const { fromDate, toDate } = action.payload;
    const result = yield call(getLeaves, {
      rmBuddyId,
      fromDate,
      toDate
    });
    yield put(setSelectedRmBuddyLeaves(result.data.leaves));
  } catch (e) {
    console.error(e);
    if (e.response.status === 401) {
      yield put(setUserAuthenticated(false));
      yield put(setReplayOnAuthentication(action));
    }
    yield put(setErrorToastMessage(e.response.data.message));
  }
  yield put(setLoaderModal(false));
}

export function* watchFetchLeavesAction() {
  yield takeLatest(FETCH_LEAVES, fetchLeavesTask);
}

export function* applyLeavesTask(action) {
  if (!action.payload) {
    return;
  }
  yield put(setLoaderModal(true));
  try {
    const rmBuddyId = yield select(
      ({ rmBuddies }) => rmBuddies.selectedRmBuddyId
    );
    const { fromDate, toDate } = action.payload;
    const result = yield call(applyLeaves, {
      rmBuddyId,
      fromDate,
      toDate
    });
    yield put(setSuccessToastMessage(result.data.message));
    // to trigger refetch of leaves.
    yield put(setSelectedRmBuddyLeaves(null));
  } catch (e) {
    console.error(e);
    if (e.response.status === 401) {
      yield put(setUserAuthenticated(false));
      yield put(setReplayOnAuthentication(action));
    }
    yield put(setErrorToastMessage(e.response.data.message));
  }
  yield put(setLoaderModal(false));
}

export function* watchApplyLeavesAction() {
  yield takeLatest(APPLY_LEAVES, applyLeavesTask);
}

export function* removeLeavesTask(action) {
  if (!action.payload) {
    return;
  }
  yield put(setLoaderModal(true));
  try {
    const rmBuddyId = yield select(
      ({ rmBuddies }) => rmBuddies.selectedRmBuddyId
    );
    const { fromDate, toDate } = action.payload;
    const result = yield call(removeLeaves, {
      rmBuddyId,
      fromDate,
      toDate
    });
    yield put(setSuccessToastMessage(result.data.message));
    // to trigger refetch of leaves.
    yield put(setSelectedRmBuddyLeaves(null));
  } catch (e) {
    console.error(e);
    if (e.response.status === 401) {
      yield put(setUserAuthenticated(false));
      yield put(setReplayOnAuthentication(action));
    }
    yield put(setErrorToastMessage(e.response.data.message));
  }
  yield put(setLoaderModal(false));
}

export function* watchRemoveLeavesAction() {
  yield takeLatest(REMOVE_LEAVES, removeLeavesTask);
}
